<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  modelValue: { type: String, default: '' },
  suggestions: { type: Array, default: () => [] },
  errorMessage: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'search', 'select']);

const updateValue = event => {
  emit('update:modelValue', event.target.value);
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section
    class="grid gap-4 rounded-lais border border-lais-border bg-white p-4 shadow-lais-card lg:grid-cols-[180px_1fr] lg:items-center"
  >
    <div
      class="grid min-h-[132px] place-items-center rounded-lais bg-lais-bg-soft text-lais-primary"
      aria-hidden="true"
    >
      <span class="i-lucide-door-open size-14" />
    </div>
    <div class="grid gap-3">
      <div>
        <p class="text-[12px] font-semibold uppercase text-lais-primary">
          Acesso ao imóvel
        </p>
        <h3 class="mt-1 text-[18px] font-semibold text-lais-text">
          Buscar instruções por código
        </h3>
        <p class="mt-1 text-[13px] leading-relaxed text-lais-text-body">
          Consulte senha, portaria, responsável e observações antes de sair para
          a visita.
        </p>
      </div>

      <form
        class="rounded-lais border border-lais-border bg-white p-2 shadow-lais-card"
        @submit.prevent="emit('search')"
      >
        <div class="flex flex-col gap-2 sm:flex-row">
          <label class="relative min-w-0 flex-1">
            <span class="sr-only">Código do imóvel</span>
            <span
              class="i-lucide-search pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-lais-text-muted"
              aria-hidden="true"
            />
            <input
              :value="modelValue"
              type="number"
              inputmode="numeric"
              min="1"
              class="h-10 w-full rounded-lais-sm border border-transparent bg-lais-bg-soft pl-9 pr-3 text-[14px] text-lais-text outline-none focus:border-lais-primary focus:bg-white"
              placeholder="Digite o código do imóvel"
              @input="updateValue"
            />
          </label>
          <button
            type="submit"
            class="inline-flex h-10 items-center justify-center gap-2 rounded-lais bg-lais-primary px-4 text-[13px] font-semibold text-white shadow-lais-soft disabled:opacity-50"
            :disabled="isLoading"
          >
            <span
              :class="
                isLoading
                  ? 'i-lucide-loader-circle animate-spin'
                  : 'i-lucide-search'
              "
              class="size-4"
              aria-hidden="true"
            />
            Buscar por código do imóvel
          </button>
        </div>
      </form>

      <div
        v-if="errorMessage"
        class="flex items-start gap-2 rounded-lais border border-rose-200 bg-rose-50 px-3 py-2 text-[13px] font-semibold text-rose-700"
      >
        <span
          class="i-lucide-triangle-alert mt-0.5 size-4"
          aria-hidden="true"
        />
        <span>{{ errorMessage }}</span>
      </div>

      <div v-if="suggestions.length" class="flex flex-wrap gap-2">
        <button
          v-for="suggestion in suggestions"
          :key="suggestion.id"
          type="button"
          class="inline-flex max-w-full items-center gap-2 rounded-full border border-lais-border bg-white px-3 py-1.5 text-[12px] font-semibold text-lais-text hover:border-lais-primary"
          @click="emit('select', suggestion)"
        >
          <span
            class="i-lucide-map-pin size-3.5 shrink-0 text-lais-primary"
            aria-hidden="true"
          />
          <span class="truncate">{{ suggestion.label }}</span>
        </button>
      </div>
    </div>
  </section>
</template>
